import { render } from "./SpecimenPickerItem.vue?vue&type=template&id=4f721772&scoped=true&ts=true"
import script from "./SpecimenPickerItem.vue?vue&type=script&lang=ts"
export * from "./SpecimenPickerItem.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f721772"]])

export default __exports__